import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFieldFormComponent } from './custom-field-form.component';
import { SharedModule } from 'app/shared/shared.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { LineItemPickerModule } from '../line-item-picker/line-item-picker.module';



@NgModule({
  declarations: [
    CustomFieldFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatExpansionModule,
    LineItemPickerModule
  ],
  exports: [
    CustomFieldFormComponent
  ]
})
export class CustomFieldFormModule { }
